import { CSSProperties } from "react";

export const shadow: CSSProperties = {
    boxShadow: '1px 0px 12px 1px rgba(0,0,0,0.05)',
    WebkitBoxShadow: '1px 0px 12px 1px rgba(0,0,0,0.05)',
    MozBoxShadow: '1px 0px 12px 1px rgba(0,0,0,0.05)'
}